import axios2 from '../api/axios';
import axiosfile from '../api/axiosfile';
export const profileservices = {
    getprofile,
    updateprofile,
    // createbillofmaterial,
}

function getprofile(){
    return axios2.get(`/getprofile`,((response)=>{
         return response;   
    })).catch((error)=>{
         console.log(error); 
    })   
}

// function createbillofmaterial(objdata){
//     return axios2.post(`/createbillofmaterial`,objdata,((response)=>{
//         return response;   
//    })).catch((error)=>{
//         console.log(error); 
//    })   
// }

function updateprofile(objdata){
    return axiosfile.post(`/updateprofile`,objdata,((response)=>{
        return response;   
   })).catch((error)=>{
        console.log(error); 
   })   
}






